/**
 * 各种画echarts图表的方法都封装在这里
 */

import * as echarts from 'echarts'
const install = function (Vue) {
  Object.defineProperties(Vue.prototype, {
    $chart: {
      get() {
        return {
          //画一条简单的线
          pie: function (res) {
            var myChart = echarts.init(document.getElementById(res.id));
            myChart.clear();

            var option = {
              tooltip: {
                trigger: 'item',
                formatter: '{a}<br>{b}: {c}({d}%)',
              },
              legend: {
                top: 'center',
                right: '10%',
                orient:'veritcal',
                formatter: function (name) {
                  return name+"："+res.obj[name];
                }
              },
              series: [
                {
                  name: '订单状态',
                  type: 'pie',
                  center: ['30%', '50%'],
                  radius: ['40%', '70%'],
                  itemStyle: {
                    borderRadius: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                  },
                  label: {
                    show:false,
                    position: 'outer',
                    alignTo: 'edge',
                    margin: 20,
                    formatter: '{b}: {c}({d}%)',
                    bleedMargin: 0
                  },
                  data: res.data
                }
              ]
            };

            myChart.setOption(option);
            window.addEventListener("resize", function () {
              myChart.resize();
            });
          },
          bar: function (res) {
            console.log(res)
            var myChart = echarts.init(document.getElementById(res.id));
            myChart.clear();
            var option = {
              tooltip: {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                  type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
                formatter: (p) => {
                  var i = p[0].dataIndex;
                  return res.name[i] + "<br>订单数：" + res.value[i] + "<br>订单金额：" + res.price[i]
                }
              },
              dataZoom: [{
                show: false,
                realtime: true,
                start: res.bar,
                end: 100,
              },
              {
                type: 'inside',
                realtime: true,
                start: res.bar,
                end: 100,
              }],
              title: [{
                text: "数据统计",
                left: "10",
                top: "10"
              }, {
                text: '暂无数据',
                left: 'center',
                top: 'center',
                show: res.name.length == 0 ? true : false
              }],
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              xAxis: [
                {
                  type: 'category',
                  data: res.name,
                  axisTick: {
                    alignWithLabel: true
                  },
                  axisLabel: {
                    interval: 0,
                    formatter: function (p) {
                      var a = p.split('-')
                      return a[1] + "-" + a[2];
                    },
                  }
                }
              ],
              yAxis: [
                {
                  type: 'value',
                  minInterval: 1
                }
              ],
              series: [
                {
                  name: '',
                  type: 'bar',
                  barWidth: '30%',
                  data: res.value,
                  itemStyle: {
                    normal: {
                      barBorderRadius: [15, 15, 0, 0],
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#5ef3ff'
                      }, {
                        offset: 1,
                        color: '#06a4f4'
                      }], false)
                    }
                  },

                }
              ]
            };
            myChart.setOption(option);
            window.addEventListener("resize", function () {
              myChart.resize();
            });
          }
        }
      }
    }
  })
}

export default {
  install
}


// WEBPACK FOOTER //
// ./src/components/utils/myCharts.js